import type {
    MonitorAndProtectParamKeys,
    MonitorAndProtectParamsDefinition,
    MonitorAndProtectTrademarkParamKeys,
    MonitorAndProtectTrademarkParamsDefinition,
} from "app/pages/digital-marketing/monitor-and-protect";
import { StateParamsConfig } from "single-spa/react-app/router/utils/state-params-build/params-config";

// See advertiser-activity/routing/constants — route objects live in the shared SI constants
// module; re-exported here for the co-located states/secondary-bar files.
export { SI_MNP_ROUTES, SI_MNP_TRADEMARK_ROUTES } from "app/common/constants/ad-intelligence-routes";

const siMnpParamsDefinition: MonitorAndProtectParamsDefinition = {
    campaignId: {
        type: "string",
        array: false,
        dynamic: true,
    },
    duration: {
        type: "string",
        array: false,
        dynamic: true,
        value: "28d",
    },
    location: {
        type: "int",
        array: true,
        dynamic: true,
    },
    device: {
        type: "string",
        array: false,
        dynamic: true,
        value: "All",
    },
    dataFilters: {
        type: "json",
        array: false,
        dynamic: true,
    },
    sortBy: {
        type: "string",
        array: false,
        dynamic: true,
    },
    sortDir: {
        type: "string",
        array: false,
        dynamic: true,
    },
} as const;

export const siMnpParams = new StateParamsConfig<MonitorAndProtectParamsDefinition, MonitorAndProtectParamKeys>(
    siMnpParamsDefinition,
);

const siMnpTrademarkParamsDefinition: MonitorAndProtectTrademarkParamsDefinition = {
    trademarkId: {
        type: "string",
        array: false,
        dynamic: true,
    },
    duration: {
        type: "string",
        array: false,
        dynamic: true,
        value: "28d",
    },
    dataFilters: {
        type: "json",
        array: false,
        dynamic: true,
    },
    sortBy: {
        type: "string",
        value: "timesSeen",
        array: false,
        dynamic: true,
    },
    sortDir: {
        type: "string",
        value: "descend",
        array: false,
        dynamic: true,
    },
} as const;

export const siMnpTrademarkParams = new StateParamsConfig<
    MonitorAndProtectTrademarkParamsDefinition,
    MonitorAndProtectTrademarkParamKeys
>(siMnpTrademarkParamsDefinition);
